import { memo } from 'react';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import { getHighlightStyles } from './HighlightStyles.js';
import { jsx } from '@emotion/react/jsx-runtime';

function defaultHighlightFn(text, query, matchOptions) {
  if (!(query !== null && query !== void 0 && query.trim())) {
    return [{
      text,
      highlight: false
    }];
  }
  const matches = match(text, query, matchOptions !== null && matchOptions !== void 0 ? matchOptions : {
    findAllOccurrences: true
  });
  const parts = parse(text, matches);
  return parts;
}
const HighlightComp = _ref => {
  let {
    query,
    searchFn,
    children,
    matchOptions,
    ...rest
  } = _ref;
  const isNotString = typeof children !== 'string';
  if (!children || isNotString) {
    if (isNotString) {
      console.warn('«Highlight» children must be an string');
    }
    return null;
  }
  const splittedText = searchFn ? searchFn(children, query) : defaultHighlightFn(children, query, matchOptions);
  return jsx("span", {
    ...rest,
    children: splittedText.map((_ref2, index) => {
      let {
        text,
        highlight
      } = _ref2;
      return highlight ? jsx("span", {
        css: getHighlightStyles,
        children: text
      }, `${text}${index}`) : jsx("span", {
        children: text
      }, `${text}${index}`);
    })
  });
};
const Highlight = /*#__PURE__*/memo(HighlightComp);

export { Highlight, defaultHighlightFn };
//# sourceMappingURL=Highlight.js.map
